import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
  AutocompleteInput,
  FileInput,
  ConfigurationContext,
  SelectInput,
} from '@kirz/mui-admin';
import React, {
  forwardRef,
  Ref,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';

import { CATEGORY_TYPE_ITEMS } from 'constants/other';

export const CategoriesTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);
    const [sortValues, setSortValues] = useState<number[] | null>(null);
    const { hasura } = useContext(ConfigurationContext);

    useImperativeHandle(ref, () => tableRef.current!, []);

    useEffect(() => {
      (async () => {
        const items = await hasura.request({
          type: 'query',
          source: 'category',
          selection: 'sort',
        });

        setSortValues(items.map((x: any) => x.sort));
      })();
    }, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          // {
          //   field: 'id',
          //   headerName: 'ID',
          //   width: 60,
          //   sortable: false,
          // },
          {
            width: 60,
            field: 'sort',
            type: 'sort',
            sortKey: 'sort',
            rowsSortValues: sortValues,
            onSortChange: async (direction, row, targetRowSort) => {
              const source = 'Category';
              const { id } = row;

              await hasura.request({
                type: 'custom',
                query: `
                  mutation ChangeSort($where1: ${source}BoolExp!, $set1: ${source}SetInput!, $where2: ${source}BoolExp!, $set2: ${source}SetInput!) {
                    result2: update${source}(where: $where2, _set: $set2) {
                      affected_rows
                    }
                    result1: update${source}(where: $where1, _set: $set1) {
                      affected_rows
                    }
                  }
                `,
                variables: {
                  where1: { id: { _eq: id } },
                  set1: { sort: targetRowSort },
                  where2: { sort: { _eq: targetRowSort } },
                  set2: { sort: row.sort },
                },
              });

              tableRef.current?.reload();
            },
          },
          {
            field: 'name',
            selector: 'name',
            headerName: 'Название',
            flex: 1,
          },
          {
            field: 'type',
            headerName: 'Тип',
            flex: 1,
            type: 'select',
            items: CATEGORY_TYPE_ITEMS,
          },
          // {
          //   field: 'sort',
          //   headerName: 'Сортировка',
          //   flex: 1,
          //   type: 'number',
          // },
          { field: 'createdAt', headerName: 'Дата создания', type: 'date' },
        ]),
      [filterColumns, sortValues],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="category"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'sort', sort: 'asc' }}
        formTitle={(isNew) =>
          isNew ? 'Новая категория' : 'Редактировать категорию'
        }
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'sm',
          formProps: {
            defaultValues: {
              ...rest.formDialogProps?.formProps?.defaultValues,
              type: 'image',
            },
          },
          formSubmitterProps: {
            preSubmit(item) {
              return {
                ...item,
              };
            },
          },
        }}
        deletable={{
          onDeleted: (row) => {
            setSortValues(sortValues!.filter((x) => x !== row.sort));
          },
        }}
      >
        <FormInput name="name" label="Название" required />
        <SelectInput
          name="type"
          label="Тип"
          required
          items={CATEGORY_TYPE_ITEMS}
        />
      </DataTableEx>
    );
  },
);
